import { useCallback, useFeatures } from 'sb-hooks'
import { ModalVisibilityProps } from 'sb-modal'
import actions from 'redux/actions'
import { constants } from 'common/helpers'
import { processVindiciaRefund } from 'compositions/modals/cancelSubscription/util'

import { closeRefundModal, openRefundModal, openSubscriptionWasCancelledModal } from 'compositions/modals/cancelSubscription'

import useUnsubscribeReasonModalBase from './useUnsubscribeReasonModalBase'


const useUnsubscribeReasonModalVindicia = (props: ModalVisibilityProps) => {
  const { closeModal, onClose } = props

  const { form, reasons, isFetching } = useUnsubscribeReasonModalBase()

  const { [constants.features.billingDay1stDayOfTheMonth]: isBillingDay1stEnabled } = useFeatures()

  const onSubmit = useCallback(async () => {
    let values

    try {
      values = await form.submit()
    }
    catch (fieldErrors) {
      console.error(fieldErrors)
      return
    }

    actions.models.ui.showRequestLoader()

    try {
      const { isRefundAvailable, refund } = await actions.models.subscription.unsubscribe({
        reason: values.reason,
        comment: values.comments.trim(),
      })

      closeModal()

      if (isRefundAvailable || refund) {
        const { status, type = 'NEW_SUBSCRIBER', transactionType = 'UNSUBSCRIBE' } = refund || {}

        const decision = await openRefundModal({ status, isBillingDay1stEnabled })

        await processVindiciaRefund({
          type,
          decision,
          transactionType,
          isBillingDay1stEnabled,
        })

        closeRefundModal()
      }

      openSubscriptionWasCancelledModal()
    }
    catch (error) {
      console.error(error)
    }

    actions.models.ui.hideRequestLoader()
  }, [ form, isBillingDay1stEnabled, closeModal ])

  return {
    form,
    reasons,
    isFetching,
    onSubmit,
    onClose,
  }
}


export default useUnsubscribeReasonModalVindicia
